import { getLocalizedValue } from '../constants/Languages';

// Utility function to get service name in the selected language
export const getServiceName = (serviceNameDict, currentLanguage, fallbackLanguage) => {
  return getLocalizedValue(serviceNameDict, currentLanguage, fallbackLanguage, 'Unnamed Service');
};

// Utility function to get all available languages for a service
export const getAvailableLanguages = (serviceNameDict) => {
  if (!serviceNameDict || typeof serviceNameDict !== 'object') {
    return [];
  }
  return Object.keys(serviceNameDict);
};
